<template>
  <div>
    <div class="material">
      <template v-if="list && list.items.length">
        <div class="edit-tool2" v-if="checkCount">
          <div class="et2-left">
            <Checkbox v-model="allCheck" @on-change="setAllChecked"></Checkbox>
            已选择{{checkCount}}张图片
            <span @click="setAllChecked(false)" class="cancle-txt">取消选择</span>
          </div>
          <div class="et2-right f-tar">
            <Poptip confirm placement="bottom-end" title="确认是否批量删除" @on-ok="handleDelImg()" @on-cancel="editVisible=false">
              <Tooltip content="删除分组" placement="top-end">
                <i style="margin-right:30px;" class="icon iconfont icon-trash"></i>
              </Tooltip>
            </Poptip>
            <Poptip placement="bottom-end" width="300" class="add-group-box2" v-model="allGroupVisible" @on-popper-hide="selectIndex2=false">
              <Tooltip content="移动分组" placement="top-end">
                <i class="icon iconfont icon-paixu-zuoyou"></i>
              </Tooltip>
              <div slot="content" class="add-group">
                <div class="title">移动至</div>
                <div class="content" v-if="albumData && albumData.items">
                  <span class="add-group-item" v-for="(c, i) in albumData.items" :class="{select: i === selectIndex2}" :key="'albumData-'+ i" @click="selectItem2(i)">{{c.name}}</span>
                </div>

                <div class="bottom">
                  <Button type="primary" :loading="groupLoading" @click="handleChangeAlbumByArr()">确定</Button>
                  <Button @click="allGroupVisible=false">取消</Button>
                </div>
              </div>
            </Poptip>
          </div>
        </div>
        <Row :gutter="30">
          <Col span="6" v-for="(item, index) in list.items" :key="'brandInt-' + index">
          <div class="material-box" :class="{select: item.checked}">
            <div class="material-img">
              <img :src="item.path" :alt="item.name" />

              <!-- 查看图片 -->
              <div class="view-info" v-if="false">
                <div class="view-tool">
                  <Icon type="ios-eye-outline" size="30" color="#fff" @click.native="handleView(item.path)" style="cursor:pointer"></Icon>
                </div>
                <div class="view-tool">
                  <Poptip confirm title="确认删除此素材吗 ?" @on-ok="delItem(item.id)">
                    <Icon type="ios-trash-outline" size="30" color="#fff"></Icon>
                  </Poptip>
                </div>
              </div>

              <!-- 查看编辑 -->
              <div class="view-edit">
                <div class="view-edit-tool">
                  <Checkbox v-model="item.checked" @on-change="setSingleChecked(index)"></Checkbox>

                  <Dropdown trigger="custom" :visible="item.dropVisible" @on-clickoutside="setDropVisible(index)">
                    <i class="icon iconfont icon-liebiao1" @click="setDropVisible(index)"></i>
                    <DropdownMenu slot="list">
                      <!-- 重命名 -->
                      <DropdownItem>
                        <Poptip placement="bottom-start" width="300" class="add-group-box" v-model="item.renameVisible" style="width: 100%">
                          重命名
                          <div slot="content" class="add-group">
                            <div class="title">素材名称</div>
                            <div class="content">
                              <Input v-model="name" :maxlength="5" placeholder="请输入素材名称" style="width: 100%" />
                            </div>
                            <div class="bottom">
                              <Button type="primary" :loading="renameLoading" @click="handleChangeAlbumName(item.id)">确定</Button>
                              <Button @click="item.renameVisible=false;name='';">取消</Button>
                            </div>
                          </div>
                        </Poptip>
                      </DropdownItem>

                      <!-- 移动分组 -->
                      <DropdownItem>
                        <Poptip placement="bottom-start" width="300" class="add-group-box2" v-model="item.groupVisible" style="width: 100%">
                          移动分组
                          <div slot="content" class="add-group">
                            <div class="title">移动至</div>
                            <div class="content" v-if="albumData && albumData.items">
                              <span class="add-group-item" v-for="(c, i) in albumData.items" :class="{select: i === selectIndex}" :key="'albumData-'+ i" @click="selectItem(i)" @on-popper-hide="selectIndex=false">{{c.name}}</span>
                            </div>

                            <div class="bottom">
                              <Button type="primary" :loading="groupLoading" @click="handleChangeAlbum(item)">确定</Button>
                              <Button @click="item.groupVisible=false">取消</Button>
                            </div>
                          </div>
                        </Poptip>
                      </DropdownItem>

                      <!-- 删除 -->
                      <DropdownItem>
                        <Poptip confirm placement="top-start" title="确认删除此素材吗 ?" @on-ok="delItem(item.id)" style="width: 100%">删除</Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div class="material-name">{{item.name}}</div>
          </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <iModal title="图片查看" cancel-text v-model="viewFlag" :mask-closable="true" width="650" :styles="{top: '150px'}">
      <img :src="viewUrl" alt="素材图片" style="width:600px;" />
    </iModal>

    <addPhoto :show="add" @close="hideAdd()" @finish="init()" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addPhoto from "../components/add-photo.vue";
export default {
  name: "photo-material-all",
  data () {
    return {
      add: false,
      list: "",
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      renameLoading: false,
      groupLoading: false,
      groupLoading2: false,
      allGroupLoading: false,
      title: "",
      name: "",
      viewUrl: "",
      viewFlag: false,
      editVisible: false,
      renameVisible: false,
      groupVisible: false,
      allGroupVisible: false,
      albumData: null,
      selectIndex: -1,
      selectIndex2: -1,
      allCheck: false,
      allCheckNum: 0,
      checkAll: false,
      checkCount: 0,
      visible: false
    };
  },
  watch: {
    $route (to, from) {
      if (to.query && to.query.id) {
        this.init();
      }
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    query () {
      return this.$router.history.current.query;
    },
    option () {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    },
    option2 () {
      return {
        CompId: this.company.id,
        pageSize: 1000
      };
    }
  },
  components: {
    addPhoto
  },
  async created () {
    this.init();
    this.getAlbumData();
  },
  methods: {
    ...mapActions({
      getMaterial: "materialModule/getMaterial",
      delMaterial: "materialModule/delMaterial",
      changeAlbumByArr: "albumModule/changeAlbumByArr",
      changeAlbum: "albumModule/changeAlbum",
      changeAlbumName: "albumModule/changeAlbumName",
      getAlbum: "albumModule/getAlbum",
      getAlbumPhotoByAlbumId: "albumModule/getAlbumPhotoByAlbumId",
      delAlbumPhoto: "albumModule/delAlbumPhoto",
      getAlbumById: "albumModule/getAlbumById",
      delAlbum: "albumModule/delAlbum",
      editAlbum: "albumModule/editAlbum",
      delBatchAlbumPhoto: "albumModule/delBatchAlbumPhoto"
    }),
    async getAlbumData () {
      this.selectIndex = -1;
      this.selectIndex2 = -1;
      const data = await this.getAlbum(this.option2);
      if (data && data.items) {
        data.items.map(c => {
          c.select = false;
        });
        this.albumData = data;
      }
    },
    selectItem (index) {
      if (this.selectIndex === index) {
        this.selectIndex = -1;
      } else {
        this.selectIndex = index;
      }
    },
    selectItem2 (index) {
      if (this.selectIndex2 === index) {
        this.selectIndex2 = -1;
      } else {
        this.selectIndex2 = index;
      }
    },
    handleView (data) {
      this.viewFlag = true;
      this.viewUrl = data;
    },
    handleRemove (data) {
      this.$Modal.confirm({
        content: `确认删除该图片吗`,
        onOk: () => {
          this.delItem(data);
        },
        onCancel: () => {
          this.deleted = false;
        }
      });
    },
    async delItem (item) {
      let result = await this.delMaterial(item);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async handleChangeAlbum (data) {
      if (this.selectIndex === -1) return;
      this.groupLoading = true;
      let formData = {
        AlbumId: this.albumData.items[this.selectIndex].id,
        PhotoId: data.id
      };
      let bool = await this.changeAlbum(formData);
      setTimeout(() => {
        this.groupLoading = false;
      }, 5000);
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.renameVisible = false;
        this.dropVisible = false;
        this.groupVisible = false;
        this.groupLoading = false;
        this.selectIndex = -1;
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async handleChangeAlbumByArr () {
      const id = this.$router.history.current.query.id;
      if (this.selectIndex2 === -1) return;
      if (!(this.list && this.list.items.length)) return;
      let reqArr = [];
      this.list.items.forEach(c => {
        if (c.checked) reqArr.push(c.id);
      });
      this.groupLoading2 = true;
      let formData = {
        AlbumId: this.albumData.items[this.selectIndex2].id,
        List: reqArr
      };
      let bool = await this.changeAlbumByArr(formData);
      setTimeout(() => {
        this.groupLoading2 = false;
      }, 5000);
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.groupLoading2 = false;
        this.selectIndex2 = -1;
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async handleDelImg () {
      if (!this.list.items) return;
      let arr = [];
      this.list.items.forEach(c => {
        if (c.checked) arr.push(c.id);
      });
      if (arr.length === 0) return;
      const req = {
        List: arr
      };
      let result = await this.delBatchAlbumPhoto(req);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async handleChangeAlbumName (id) {
      this.renameLoading = true;
      let formData = {
        Id: id,
        Name: this.name
      };
      let bool = await this.changeAlbumName(formData);
      setTimeout(() => {
        this.renameLoading = false;
      }, 5000);
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.renameLoading = false;
        this.renameVisible = false;
        this.dropVisible = false;
        this.name = "";
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    showAdd () {
      this.add = true;
    },
    hideAdd () {
      this.add = false;
    },
    async init () {
      this.checkCount = 0;
      this.allCheck = false;
      this.allGroupVisible = false;
      let listData = await this.getMaterial(this.option);
      if (listData) {
        listData.items.sort((a, b) => {
          let lastTime = new Date(a.inTime).getTime();
          let endTime = new Date(b.inTime).getTime();
          return lastTime > endTime;
        });
        listData.items.map(c => {
          c.checked = false;
          c.dropVisible = false;
          c.renameVisible = false;
          c.groupVisible = false;
        });
        this.list = listData;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
      this.$emit("finish");
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    setAllChecked (bool) {
      let count = 0;
      this.list.items.map(c => {
        c.checked = bool;
        if (c.checked) count += 1;
      });
      this.checkCount = count;
      if (this.checkCount === this.list.items.length) {
        this.allCheck = true;
      } else {
        this.allCheck = false;
      }
    },
    setSingleChecked (index) {
      let count = 0;
      this.list.items.map((c, idx) => {
        if (c.checked) count += 1;
      });
      this.checkCount = count;
      if (this.checkCount === this.list.items.length) {
        this.allCheck = true;
      } else {
        this.allCheck = false;
      }
    },
    setDropVisible (index) {
      this.list.items.map((c, idx) => {
        if (index === idx) {
          c.dropVisible = !c.dropVisible;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.ivu-poptip-rel {
  width: 100%;
}
.add-group-box2 {
  .ivu-poptip-body {
    padding: 0;
    margin: 0;
    width: 300px;
    height: 358px;
  }
  .add-group {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
    text-align: left;
    &-item {
      display: inline-block;
      padding: 9px 10px;
      border-radius: 5px;
      border: solid 1px #bfbfbf;
      margin: 0 10px 10px 0;
      color: #333;
      cursor: pointer;
      &:hover,
      &.select {
        color: #178fff;
        border-color: #178fff;
      }
    }
  }
  .title {
    padding: 20px 30px;
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #ddd;
  }
  .content {
    padding: 16px;
    height: 233px;
    white-space: normal;
    width: 300px;
    overflow: auto;
  }
  .bottom {
    border-top: 1px solid #ddd;
    text-align: right;
    padding: 12px 30px;
    button {
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.edit {
  &-tool {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .et {
      &-title {
        flex: 1;
        font-size: 20px;
        display: flex;
        align-items: center;
        height: 50px;
        span {
          margin-right: 5px;
          display: inline-block;
        }
        .iconfont {
          font-size: 25px;
          display: inline-block;
          margin-right: 2px;
          cursor: pointer;
        }
      }
      &-back {
        width: 100px;
        text-align: right;
      }
    }
  }
  &-tool2 {
    width: 100%;
    height: 50px;
    padding: 0 40px 0 20px;
    margin-bottom: 20px;
    background-color: #ddd;
    display: flex;
    align-items: center;
    .et2 {
      &-left {
        .cancle-txt {
          color: #178fff;
          cursor: pointer;
        }
      }
      &-right {
        flex: 1;
        .iconfont {
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.material {
  background-color: #fff;
  padding: 20px 40px;
  min-height: 500px;
  &-img {
    width: 100%;
    padding-bottom: 66.666667%;
    display: inline-block;
    position: relative;
    cursor: pointer;
    transition: all 0.8s;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
      &:hover + .view-info,
      &:hover + .view-edit {
        visibility: visible;
      }
    }
  }
  &-name {
    line-height: 42px;

    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-box {
    margin-bottom: 20px;
    &.select {
      .view-edit {
        visibility: visible;
      }
    }
  }
}
.view-info {
  visibility: hidden;
  width: 100%;
  height: 100%;
  padding: 0 22%;
  top: 0;
  right: 0;
  position: absolute;
  background-color: rgba(55, 55, 55, 0.6);
  font-weight: bold;
  display: flex;
  &:hover {
    visibility: visible;
  }
}
.view-edit {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  visibility: hidden;
  padding: 10px;
  &-tool {
    display: flex;
    height: 20px;
    justify-content: space-between;
    width: 100%;
  }
  &:hover {
    visibility: visible;
  }
  .iconfont {
    font-size: 20px;
    color: #fff;
    position: relative;
    top: -5px;
  }
}
.view-tool {
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  .ivu-poptip {
    cursor: pointer;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 50px;
    height: 50px;
    .ivu-poptip {
      width: 50px;
      height: 50px;
    }
  }
}
</style>